import { useInterval } from "@otto-ec/otto-components-utils/svelte/useInterval";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useMask = (
  getFloater: () => HTMLElement | undefined,
  getFloaterTarget: () => HTMLElement | undefined,
): void => {
  const maskElement = $derived.by(() => {
    const floaterTarget = getFloaterTarget();
    if (!floaterTarget) return undefined;

    if (floaterTarget.dataset.ocFloatingFocusV1Masked === undefined) return undefined;

    let ele = floaterTarget.querySelector<HTMLElement>("[data-oc-floating-focus-v1-mask-element]");

    /*                                                  */
    if (!ele) {
      const shadowRoot = floaterTarget.closest(":host > *")?.parentNode;
      if (shadowRoot) {
        ele = shadowRoot.querySelector<HTMLElement>("[data-oc-floating-focus-v1-mask-element]");
      }
    }

    return ele;
  });

  /*                                         */
  let maskRect = $state<DOMRect>();

  $effect(() => {
    if (!maskElement) return;
    const update = (): void => {
      maskRect = maskElement.getBoundingClientRect();
    };

    update();
    return useInterval(update, 100);
  });

  /*                                                   */
  const maskDimensions = $derived.by(() => {
    const floaterTarget = getFloaterTarget();
    if (!maskElement || !maskRect || !floaterTarget)
      return {
        top: 0,
        left: 0,
        width: 0,
        height: 0,
      };

    const floaterTargetRect = floaterTarget.getBoundingClientRect();

    return {
      width: maskRect.width,
      height: maskRect.height,
      top: maskRect.top - floaterTargetRect.top,
      left: maskRect.left - floaterTargetRect.left,
    };
  });

  /*                                             */
  $effect(() => {
    const floater = getFloater();
    if (!floater) return;
    floater.style.setProperty("--mask-width", `${maskDimensions.width}px`);
    floater.style.setProperty("--mask-height", `${maskDimensions.height}px`);
    floater.style.setProperty("--mask-top", `${maskDimensions.top}px`);
    floater.style.setProperty("--mask-left", `${maskDimensions.left}px`);
  });
};
